import i18n from 'modules/core/lib/i18n'
import { REQUEST_STATUSES, RequestStatus } from 'modules/planning/consts/request_status'

type PeriodHelpersItem = {
  startDate?: string | null
  endDate?: string | null
  submissionPeriods?: Array<{
    startDate: string
    endDate: string
  }> | null
}

export function getRequestStatus(item: PeriodHelpersItem): RequestStatus {
  const submissionPeriod = item.submissionPeriods?.[0]
  if (!submissionPeriod) return REQUEST_STATUSES.pending

  const now = new Date()
  const startDate = new Date(submissionPeriod.startDate)
  const endDate = new Date(submissionPeriod.endDate)

  if (now < startDate) return REQUEST_STATUSES.pending
  if (now > endDate) return REQUEST_STATUSES.finished
  return REQUEST_STATUSES.active
}

export function getRequestDeadline(item: PeriodHelpersItem): string | undefined {
  const submissionPeriod = item.submissionPeriods?.[0]
  if (!submissionPeriod) return undefined

  const now = new Date()
  const endDate = new Date(submissionPeriod.endDate)
  const diffMs = endDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays < 0) return i18n.t('planning.periods_page.deadline.passed')
  if (diffDays === 0) return i18n.t('planning.periods_page.deadline.today')
  return i18n.t('planning.periods_page.deadline.in_days', { count: diffDays })
}

export function formatPeriod(item: PeriodHelpersItem): string {
  if (!item.startDate || !item.endDate) return ''
  const start = new Date(item.startDate)
  const end = new Date(item.endDate)
  const fmt = (d: Date) =>
    d.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })

  return i18n.t('planning.periods_page.columns.date_period', {
    start_date: fmt(start),
    end_date: fmt(end),
  })
}
